import { StyleSheet } from 'aphrodite';
import { brandPrimary, destructive, mention, titles, grayIconFill } from '../../../web/styles/colors';
import { BreakPoints, CssSelectors } from '../../../web/styles/styles';
import { MobileBreakpoint } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '60px 20px',
		textAlign: 'center',
		minHeight: 400,
	},
	title: {
		fontSize: 24,
		fontWeight: 600,
		color: titles,
		marginBottom: 20,
	},
	meetingDetails: {
		marginBottom: 30,
	},
	meetingTitle: {
		fontSize: 18,
		fontWeight: 500,
		color: titles,
		marginBottom: 8,
	},
	hostName: {
		fontSize: 16,
		color: grayIconFill,
		marginBottom: 8,
	},
	dateTime: {
		background: `var(--scheduler-accent-tint, ${mention})`,
		borderRadius: 30,
		fontSize: 14,
		padding: '9px 19px',
		display: 'inline-block',
	},
	warning: {
		fontSize: 14,
		color: grayIconFill,
		marginBottom: 20,
		maxWidth: 400,
	},
	reasonContainer: {
		width: '100%',
		maxWidth: 400,
		marginBottom: 20,
		textAlign: 'left',
	},
	reasonLabel: {
		display: 'block',
		fontSize: 14,
		color: grayIconFill,
		marginBottom: 8,
	},
	reasonTextarea: {
		width: '100%',
		padding: 12,
		fontSize: 14,
		borderRadius: 8,
		border: '1px solid #ddd',
		resize: 'vertical',
		fontFamily: 'inherit',
		':focus': {
			outline: 'none',
			borderColor: `var(--scheduler-accent-fill, ${brandPrimary})`,
		},
		':disabled': {
			backgroundColor: '#f5f5f5',
			cursor: 'not-allowed',
		},
	},
	buttonContainer: {
		display: 'flex',
		gap: 16,
		justifyContent: 'center',
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			flexDirection: 'column',
			width: '100%',
			maxWidth: 300,
		},
	},
	cancelButton: {
		backgroundColor: destructive,
		color: '#fff',
		border: 'none',
		borderRadius: 30,
		padding: '12px 32px',
		fontSize: 16,
		fontWeight: 500,
		cursor: 'pointer',
		':hover': {
			opacity: 0.9,
		},
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	errorMessage: {
		fontSize: 16,
		color: destructive,
		marginBottom: 20,
	},
	successMessage: {
		fontSize: 16,
		color: `var(--scheduler-accent-link, ${brandPrimary})`,
		marginBottom: 20,
	},
	confirmation: {
		...CssSelectors.allChildren(
			{
				fontSize: 24,
				fontWeight: 600,
				color: titles,
				marginBottom: 20,
			},
			'h2'
		),
		...CssSelectors.allChildren(
			{
				fontSize: 16,
				color: grayIconFill,
				marginBottom: 10,
			},
			'p'
		),
	},
	loadingContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: 300,
	},
});
